var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center gap-8"},[_c('img',{attrs:{"src":require("~/assets/icons/" + _vm.network.value + ".png"),"height":"18"}}),_c('div',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.network.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }